import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import { Card } from "reactstrap";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import { Box } from "@mui/material";

import { columns } from "./columns";
import { saveUser } from "../../../store/actions/admin";

const UsersList = () => {
    const { users, tokens, contracts } = useSelector((state) => state.admin);
    const dispatch = useDispatch();
    const history = useHistory();
    const { pathname } = useLocation();

    const dataToRender = () => {
        if (!users || !tokens || !contracts) {
            return [];
        } else {
            return users.map((user) => {
                const userContracts = contracts.filter(
                    (contract) => user._id === contract.user
                );
                const userTokens = tokens.filter((token) =>
                    userContracts.find(
                        (contract) => contract._id === token.contractId
                    )
                );

                return {
                    ...user,
                    contracts: userContracts.length,
                    tokens: userTokens.length,
                    setBatchMint: (value) =>
                        dispatch(saveUser({ ...user, batchMint: value })),
                    setOwnPinata: (value) =>
                        dispatch(saveUser({ ...user, isOwnPinata: value })),
                    onCellClick: (userId) =>
                        history.push(`${pathname}/${userId}`),
                };
            });
        }
    };

    return (
        <Box sx={{ flexBasis: "75%" }}>
            <Card className="overflow-hidden">
                <div className="react-dataTable">
                    <DataTable
                        noHeader
                        responsive
                        columns={columns}
                        sortIcon={<ChevronDown />}
                        highlightOnHover
                        pointerOnHover
                        onRowClicked={({ _id }) =>
                            history.push(`${pathname}/${_id}`)
                        }
                        className="react-dataTable"
                        data={dataToRender()}
                    />
                </div>
            </Card>
        </Box>
    );
};

export default UsersList;
